// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5--aQ","delete":"styles_delete__39uWx","update":"styles_update__1IEg8","add":"styles_add__giHNC"};